import { tzAxios } from 'api/axios';
import { CreateHoldTokenResponse } from 'api/responseTypes';

export const createHoldToken = async (): Promise<CreateHoldTokenResponse> => {
  const response = await tzAxios.post<CreateHoldTokenResponse>(
    '/ticket-zone/event/create-hold-token',
  );
  return response.data;
};
